import React from "react";

/**COMPONENTS IMPORT */
import PageHero from "../Components/PageHero";

const CaseStudy=()=>{
    return(
        <>

    {/**HERO SECTION */}
    <PageHero heading={"Case Studies"}/>

        </>
    )
}

export default CaseStudy;